import { Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";
import { trackPhoneCallLead } from "@/lib/ads";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-background px-5 py-16 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-10 lg:grid-cols-[1.5fr_1fr_1fr_1fr_1fr]">
          <div>
            <Logo href="#top" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-muted-foreground">{BRAND.tagline} Specialized bed bug treatment across Vancouver and the Lower Mainland.</p>
          </div>
          <div>
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">Explore</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/about" className="text-foreground hover:text-accent">About</Link></li>
              <li><Link to="/contact" className="text-foreground hover:text-accent">Contact</Link></li>
              <li><Link to="/bed-bug-treatment-vancouver" className="text-foreground hover:text-accent">Bed Bug Treatment Vancouver</Link></li>
              <li><a href="#difference" className="text-foreground hover:text-accent">The Difference</a></li>
              <li><a href="#treatment" className="text-foreground hover:text-accent">Treatment</a></li>
              <li><a href="#preparation" className="text-foreground hover:text-accent">Preparation</a></li>
              <li><Link to="/guide" className="text-foreground hover:text-accent">Bed Bug Guide</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">Service Areas</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/bed-bug-treatment-areas" className="font-medium text-foreground hover:text-accent">All Service Areas</Link></li>
              {BRAND.areas.map((a) => <li key={a}><Link to={a === "Vancouver" ? "/bed-bug-treatment-vancouver" : `/bed-bug-treatment/${a.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`} className="text-foreground hover:text-accent">{a}</Link></li>)}
            </ul>
          </div>
          <div>
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">Property Types</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/bed-bug-treatment/condos" className="text-foreground hover:text-accent">Condos</Link></li>
              <li><Link to="/bed-bug-treatment/apartments" className="text-foreground hover:text-accent">Apartments</Link></li>
              <li><Link to="/bed-bug-treatment/hotels" className="text-foreground hover:text-accent">Hotels</Link></li>
              <li><Link to="/bed-bug-treatment/short-term-rentals" className="text-foreground hover:text-accent">Airbnb & Short-Term Rentals</Link></li>
              <li><Link to="/bed-bug-treatment/homes" className="text-foreground hover:text-accent">Homes</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">Contact</h3>
            <ul className="mt-4 space-y-3 text-sm">
              <li><a href={`tel:${BRAND.phoneTel}`} onClick={trackPhoneCallLead} className="flex items-center gap-2 text-foreground hover:text-accent"><Phone className="h-4 w-4" /> {BRAND.phoneDisplay}</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row">
          <p>© {new Date().getFullYear()} {BRAND.full}. All rights reserved.</p>
          <p>Vancouver, BC, Canada</p>
        </div>
      </div>
    </footer>
  );
}